import React, { useCallback } from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import renderInputField from 'components/FormControls/textInput'
import { toFixedIfNecessary } from 'utils/toFixedIfNecessary'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'

export const ClientPercentCell = ({
  disabled,
  index,
  total_percent: totalPercent,
}) => {
  const checkValue = useCallback(
    (value, max_value) =>
      isNaN(+value) || +value > max_value
        ? max_value
        : value === '' || +value < 0
        ? 0
        : value,
    [],
  )

  return (
    <Field
      component={renderInputField}
      name={`settings[${index}]`}
      type="text"
      size={'s'}
      disabled={disabled}
      inputMode={'numeric'}
      format={({ client_percent }) => client_percent}
      normalizeOnBlur={(e) =>
        +toFixedIfNecessary(checkValue(e.target.value, totalPercent))
      }
      normalize={(value, { total_percent, ...rest }) => {
        const clientPercent = checkValue(onlyNumbers(value), total_percent)
        return {
          ...rest,
          total_percent,
          client_percent: onlyNumbers(value),
          partner_percent: +toFixedIfNecessary(+total_percent - +clientPercent),
        }
      }}
    />
  )
}

ClientPercentCell.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  total_percent: PropTypes.number,
}
